// Kauf-Leiste der Produktseite: sichtbar, sobald der Kaufbereich nach OBEN aus dem Bild
// gescrollt ist. Die Richtung zu prüfen ist der ganze Trick — allein auf „nicht im Bild" zu
// hören, zeigt die Leiste schon ganz oben, bevor jemand den Knopf überhaupt gesehen hat.
// Ohne dieses Skript bleibt die Leiste `hidden`, der Knopf im Fluss genügt dann.
(() => {
  const leiste = document.querySelector('[data-kaufleiste]');
  const anker = document.querySelector('.product-form__buttons');
  if (!leiste || !anker || !('IntersectionObserver' in window)) return;

  leiste.hidden = false;
  leiste.classList.add('kaufleiste--bereit');

  const beobachter = new IntersectionObserver(
    ([eintrag]) => {
      const darueber = eintrag.boundingClientRect.top < 0;
      leiste.classList.toggle('kaufleiste--sichtbar', !eintrag.isIntersecting && darueber);
    },
    { rootMargin: '0px 0px -60px 0px' }
  );
  beobachter.observe(anker);
})();
